import React from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';
import Tag from '../../Utils/Tag';
import { ReactComponent as Dot } from '../../../images/icon/dot.svg';

interface IProps {
    type?: number; // 1:直式 2:橫式
    image: string;
    category?: string;
    title: string;
    tags?: ITag[];
    scrollAnimation?: boolean;
    className?: string;
}

const ArticleWithTagsType: React.FC<IProps> = ({
    type, image, category, title, tags, scrollAnimation, className
}): JSX.Element => (
    <div className={classnames({ [styles.straight]: type === 1, [styles.horizontal]: type === 2 }, styles.article, className)} data-aos={scrollAnimation ? 'fade-up' : ''}>
        <div className={styles.imageContainer}>
            <div className={styles.imageContainer2}>
                <img src={process.env.REACT_APP_API_ENDPOINT + image} alt="" />
            </div>
        </div>
        <div className={styles.contentContainer}>
            <div className={styles.top}>
                {category && (
                    <div className={styles.category}>
                        <Dot />
                        {category}
                    </div>
                )}
                <div className={classnames({ [styles.noCategory]: !category }, styles.title)}>
                    {title}
                </div>
            </div>
            <div className={styles.tags}>
                {tags?.map(tag => (
                    <Tag text={tag.name} key={tag.id} />
                ))}
            </div>
        </div>
    </div>
);
ArticleWithTagsType.defaultProps = {
    type: 1, // 1:直式, 2:橫式
    category: '',
    scrollAnimation: true,
    className: '',
    tags: []
};
export default ArticleWithTagsType;
